import { useEffect, useRef, useState, useCallback } from "react";

import WHS1_1 from "../../assets/images/watts-happening/whs1-1.webp";
import WHS1_2 from "../../assets/images/watts-happening/whs1-2.webp";
import WHS1_3 from "../../assets/images/watts-happening/whs1-3.webp";
import WHS1_4 from "../../assets/images/watts-happening/whs1-4.webp";

import WHS2_1 from "../../assets/images/watts-happening/whs2-1.webp";
import WHS2_2 from "../../assets/images/watts-happening/whs2-2.webp";
import WHS2_3 from "../../assets/images/watts-happening/whs2-3.webp";
import WHS2_4 from "../../assets/images/watts-happening/whs2-4.webp";

import WHS3_1 from "../../assets/images/watts-happening/whs3-1.webp";
import WHS3_2 from "../../assets/images/watts-happening/whs3-2.webp";
import WHS3_3 from "../../assets/images/watts-happening/whs3-1.webp";
import WHS3_4 from "../../assets/images/watts-happening/whs3-2.webp";

/* ─────────────────────────────────────────────
   PREFIX: wh-
───────────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Roboto:wght@400;500&display=swap');

  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  .wh-page {
    background: #1A1A1A;
    min-height: 100vh;
    font-family: 'Roboto', sans-serif;
    color: #fff;
  }
  .wh-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 102px;
    padding-right: 102px;
  }

  /* ── PAGE TITLE ── */
  .wh-page-title {
    font-family: 'Montserrat', sans-serif;
    font-size: 50px;
    font-weight: 700;
    text-align: center;
    color: #ffffff;
    padding-top: 60px;
    padding-bottom: 60px;
    letter-spacing: -0.5px;
  }

  /* ── SEASON BLOCK ── */
  .wh-season { padding-bottom: 80px; }
  .wh-season:last-of-type { padding-bottom: 100px; }

  /* ── DRAGGABLE SLIDER ── */
  .wh-slider {
    overflow: hidden;
    cursor: grab;
    user-select: none;
  }
  .wh-slider.wh-dragging { cursor: grabbing; }
  .wh-slider__track {
    display: flex;
    gap: 30px;
    will-change: transform;
  }
  .wh-slider__item {
    flex: 0 0 calc((100% - 48px) / 3);
    min-width: 0;
  }
  .wh-slider--2 .wh-slider__item {
    flex: 0 0 calc((100% - 24px) / 2);
  }

  /* ── CARD ── */
  .wh-card {
    position: relative;
    border-radius: 12px;
    overflow: hidden;
    cursor: pointer;
    height:300px;
    background: #000;
    display: block;
    width: 100%;
  }
  .wh-card img.wh-card__thumb {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    transition: transform 0.4s ease;
    pointer-events: none;
  }
  .wh-card:hover img.wh-card__thumb {
    transform: scale(1.04);
  }
  .wh-card__overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(to top, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.1) 60%, transparent 100%);
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    padding: 20px 24px;
    pointer-events: none;
    display:none;
  }
  .wh-card__season-label {
    font-family: 'Roboto', sans-serif;
    font-size: 12px;
    font-weight: 500;
    color: #dddddd;
    margin-bottom: 4px;
  }
  .wh-card__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 20px;
    font-weight: 700;
    color: #ffffff;
    line-height: 130%;
    margin-bottom: 6px;
  }
  .wh-card__subtitle {
    font-family: 'Roboto', sans-serif;
    font-size: 12px;
    font-weight: 400;
    color: #cccccc;
    line-height: 140%;
  }

  /* ── DOTS ── */
  .wh-dots {
    display: flex;
    justify-content: center;
    gap: 8px;
    margin-top: 34px;
  }
  .wh-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #555555;
    border: none;
    cursor: pointer;
    padding: 0;
    transition: background 0.2s ease;
  }
  .wh-dot.wh-dot--active { background: #743FAC; }

  /* ── YOUTUBE MODAL ── */
  .wh-modal {
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.88);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
  }
  .wh-modal__content {
    position: relative;
    width: 90%;
    max-width: 960px;
  }
  .wh-modal__iframe-wrap {
    position: relative;
    padding-bottom: 56.25%;
    height: 0;
    border-radius: 12px;
    overflow: hidden;
  }
  .wh-modal__iframe-wrap iframe {
    position: absolute;
    top: 0; left: 0;
    width: 100%; height: 100%;
    border: none;
  }
  .wh-modal__close {
    position: absolute;
    top: -40px;
    right: 0;
    background: none;
    border: none;
    color: #fff;
    font-size: 32px;
    cursor: pointer;
    line-height: 1;
  }

  /* ── TABLET (max 768px) ── */
  @media (max-width: 768px) {
    .wh-inner { padding-left: 32px; padding-right: 32px; }
    .wh-page-title { font-size: 32px; padding-top: 32px; padding-bottom: 32px; }
    .wh-slider__item { flex: 0 0 calc((100% - 32px) / 3); }
    .wh-slider--2 .wh-slider__item { flex: 0 0 calc((100% - 16px) / 2); }
    .wh-slider__track { gap: 16px; }
    .wh-card__title { font-size: 15px; }
    .wh-card {aspect-ratio:16/9; height:auto;}
    .wh-dots {margin-top: 18px;}
    .wh-season { padding-bottom: 40px; }
  }

  /* ── MOBILE (max 480px) ── */
  @media (max-width: 480px) {
    .wh-inner { padding-left: 16px; padding-right: 16px; }
    .wh-page-title { font-size: 30px; padding-top: 30px; padding-bottom: 30px; }
    .wh-slider__track { gap: 0px; }
    .wh-slider__item { flex: 0 0 100%;padding-right:10px; }
    .wh-slider--2 .wh-slider__item { flex: 0 0 100%; }
    .wh-card { width: 100%; height: 223px; }
    .wh-card__title { font-size: 18px; }
    .wh-season { padding-bottom: 30px; }
    .wh-season:last-of-type { padding-bottom: 50px; }
        .wh-dots {margin-top: 15px;}
  }
`;

/* ─────────────────────────────────────────────
   DATA
───────────────────────────────────────────── */
const SEASON1 = [
  { img: WHS1_1, title: "Watts Happening #1", subtitle: "Tata Group, Ather, Tesla & more!", ytId: "SZmu1JGDEio" },
  { img: WHS1_2, title: "Watts Happening #2", subtitle: "Maruti, BYD, River & more",        ytId: "S4EgROivoOg" },
  { img: WHS1_3, title: "Watts Happening #3", subtitle: "Rivian, BYD, & Tesla",             ytId: "HiDU2XOm2Wg" },
  { img: WHS1_4, title: "Watts Happening #4", subtitle: "",                                 ytId: "etU5PNrpkag" },
];

const SEASON2 = [
  { img: WHS2_1, title: "Watts Happening #1", subtitle: "Tata Curvy, Ferrari & Rimac Robo-Taxi",       ytId: "Kso2kpvIAxA" },
  { img: WHS2_2, title: "Watts Happening #2", subtitle: "BYD's Ultra Fast Charging, Ola",              ytId: "" },
  { img: WHS2_3, title: "Watts Happening #3", subtitle: "Tesla We-Robot, Ola, Ather IPO & MG Windsor", ytId: "" },
  { img: WHS2_4, title: "Watts Happening #4", subtitle: "",                                            ytId: "" },
];

const SEASON3 = [
  { img: WHS3_1, title: "Watts Happening #1", subtitle: "BYD's Ultra Fast Charging, Maruti's eVitara, Hyundai Creta EV, MG Cyberstar,", ytId: "zgtdLBtmvRQ" },
  { img: WHS3_2, title: "Watts Happening #2", subtitle: "Tesla, MG Windsor, MG Select & much more.",                                     ytId: "w73XoIJYx9o" },
  { img: WHS3_3, title: "Watts Happening #3", subtitle: "", ytId: "REPLACE_ID_3" },
  { img: WHS3_4, title: "Watts Happening #4", subtitle: "", ytId: "REPLACE_ID_4" },
];

/* ─────────────────────────────────────────────
   YOUTUBE MODAL
───────────────────────────────────────────── */
function Modal({ ytId, onClose }) {
  useEffect(() => {
    const handler = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [onClose]);

  return (
    <div className="wh-modal" onClick={onClose}>
      <div className="wh-modal__content" onClick={(e) => e.stopPropagation()}>
        <button className="wh-modal__close" onClick={onClose}>&#x2715;</button>
        <div className="wh-modal__iframe-wrap">
          <iframe
            src={`https://www.youtube.com/embed/${ytId}?autoplay=1&rel=0`}
            title="Watts Happening"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      </div>
    </div>
  );
}

/* ─────────────────────────────────────────────
   CARD
───────────────────────────────────────────── */
function WattsCard({ img, title, subtitle, ytId, seasonLabel, onPlay, isDragging }) {
  const handleClick = () => {
    if (!isDragging && ytId) onPlay(ytId);
  };
  return (
    <div className="wh-card" onClick={handleClick}>
      <img className="wh-card__thumb" src={img} alt={title} />
      <div className="wh-card__overlay">
        {seasonLabel && <span className="wh-card__season-label">{seasonLabel}</span>}
        <h3 className="wh-card__title">{title}</h3>
        {subtitle && <p className="wh-card__subtitle">{subtitle}</p>}
      </div>
    </div>
  );
}

/* ─────────────────────────────────────────────
   INFINITE AUTOPLAY + DRAGGABLE SLIDER
───────────────────────────────────────────── */
function SeasonSlider({ episodes, seasonLabel, onPlay, visible = 3, noDots = false }) {
  const GAP = 30;
  const total = episodes.length;

  // On mobile (≤480px) always show 1 slide at a time
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 480);
  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth <= 480);
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);

  const effectiveVisible = isMobile ? 1 : visible;
  const effectiveGap     = isMobile ? 0 : GAP;

  const maxIndex = Math.max(0, total - effectiveVisible);
  const dotCount = total; // one dot per slide

  // clone first `effectiveVisible` slides and append to end
  const cloned = [...episodes, ...episodes.slice(0, effectiveVisible)];

  const [trackIndex, setTrackIndex] = useState(0);
  const [activeDot, setActiveDot]   = useState(0);
  const [animated, setAnimated]     = useState(true);
  const [isDragging, setIsDragging] = useState(false);

  const sliderRef        = useRef(null);
  const trackRef         = useRef(null);
  const startX           = useRef(0);
  const startTrackIndex  = useRef(0);
  const dragged          = useRef(false);
  const autoRef          = useRef(null);

  const getItemWidth = () => {
    if (!sliderRef.current) return 0;
    const w = sliderRef.current.offsetWidth;
    return (w - effectiveGap * (effectiveVisible - 1)) / effectiveVisible;
  };

  const getOffset = (ti) => -(ti * (getItemWidth() + effectiveGap));

  useEffect(() => {
    setTrackIndex(0);
    setActiveDot(0);
    setAnimated(false);
  }, [isMobile]);

  /* ── Autoplay ── */
  const startAuto = useCallback(() => {
    clearInterval(autoRef.current);
    autoRef.current = setInterval(() => {
      setAnimated(true);
      setTrackIndex((ti) => ti + 1);
    }, 3500);
  }, []);

  useEffect(() => {
    startAuto();
    const handleVisibility = () => {
      if (document.hidden) {
        clearInterval(autoRef.current);
      } else {
        setTrackIndex((ti) => {
          const safe = ti >= total ? 0 : Math.min(ti, maxIndex);
          setActiveDot(safe % total);
          setAnimated(false);
          return safe;
        });
        startAuto();
      }
    };
    document.addEventListener("visibilitychange", handleVisibility);
    return () => {
      clearInterval(autoRef.current);
      document.removeEventListener("visibilitychange", handleVisibility);
    };
  }, [startAuto, total, maxIndex]);

  /* ── After each transition: sync activeDot, snap back from clone zone ── */
  const handleTransitionEnd = useCallback(() => {
    setTrackIndex((ti) => {
      if (ti >= total) {
        const real = ti - total;
        setAnimated(false);
        setActiveDot(real % total);
        return real;
      }
      setActiveDot(ti % total);
      return ti;
    });
  }, [total]);

  /* ── Dot click ── */
  const goTo = useCallback((realIdx) => {
    clearInterval(autoRef.current);
    const ti = Math.min(realIdx, maxIndex);
    setAnimated(true);
    setTrackIndex(ti);
    setActiveDot(realIdx % total);
    startAuto();
  }, [startAuto, maxIndex, total]);

  /* ── Drag ── */
  const onPointerDown = (e) => {
    clearInterval(autoRef.current);
    setIsDragging(true);
    dragged.current = false;
    startX.current = e.clientX ?? e.touches?.[0]?.clientX;
    startTrackIndex.current = trackIndex;
    setAnimated(false);
  };

  const onPointerMove = (e) => {
    if (!isDragging) return;
    const x = e.clientX ?? e.touches?.[0]?.clientX;
    const diff = x - startX.current;
    if (Math.abs(diff) > 5) dragged.current = true;
    if (trackRef.current) {
      trackRef.current.style.transform =
        `translateX(${getOffset(startTrackIndex.current) + diff}px)`;
    }
  };

  const onPointerUp = (e) => {
    if (!isDragging) return;
    setIsDragging(false);
    if (trackRef.current) trackRef.current.style.transform = "";
    const x   = e.clientX ?? e.changedTouches?.[0]?.clientX;
    const diff = x - startX.current;
    const itemW = getItemWidth();
    let next = startTrackIndex.current;
    if (Math.abs(diff) > itemW * 0.25) {
      next = diff < 0
        ? Math.min(startTrackIndex.current + 1, total + effectiveVisible - effectiveVisible)
        : Math.max(startTrackIndex.current - 1, 0);
    }
    setAnimated(true);
    setTrackIndex(next);
    setActiveDot(next % total);
    startAuto();
  };

  const translateX = getOffset(trackIndex);

  return (
    <div className="wh-season">
      <div
        ref={sliderRef}
        className={`wh-slider${isDragging ? " wh-dragging" : ""}${effectiveVisible === 2 ? " wh-slider--2" : ""}`}
        onMouseDown={onPointerDown}
        onMouseMove={onPointerMove}
        onMouseUp={onPointerUp}
        onMouseLeave={isDragging ? onPointerUp : undefined}
        onTouchStart={onPointerDown}
        onTouchMove={onPointerMove}
        onTouchEnd={onPointerUp}
      >
        <div
          ref={trackRef}
          className="wh-slider__track"
          style={{
            transform: `translateX(${translateX}px)`,
            transition: animated ? "transform 0.35s ease" : "none",
          }}
          onTransitionEnd={handleTransitionEnd}
        >
          {cloned.map((ep, i) => (
            <div className="wh-slider__item" key={i}>
              <WattsCard
                {...ep}
                seasonLabel={seasonLabel}
                onPlay={onPlay}
                isDragging={dragged.current}
              />
            </div>
          ))}
        </div>
      </div>

      {/* Dots: dotCount dots, activeDot highlights the current one */}
      {dotCount > 1 && !noDots && (
        <div className="wh-dots">
          {Array.from({ length: dotCount }).map((_, i) => (
            <button
              key={i}
              className={`wh-dot${activeDot === i ? " wh-dot--active" : ""}`}
              onClick={() => goTo(i)}
              aria-label={`Page ${i + 1}`}
            />
          ))}
        </div>
      )}
    </div>
  );
}

/* ─────────────────────────────────────────────
   ROOT
───────────────────────────────────────────── */
export default function WattsHappening() {
  const [activeYt, setActiveYt] = useState(null);

  return (
    <>
      <style>{CSS}</style>
      <div className="wh-page">
        <div className="wh-inner">
          <h1 className="wh-page-title">Watts Happening</h1>

          <SeasonSlider episodes={SEASON1} seasonLabel={null}     onPlay={setActiveYt} />
          <SeasonSlider episodes={SEASON2} seasonLabel="Season 2" onPlay={setActiveYt} />
          <SeasonSlider episodes={SEASON3} seasonLabel="Season 3" onPlay={setActiveYt} visible={2} noDots />
        </div>
      </div>

      {activeYt && <Modal ytId={activeYt} onClose={() => setActiveYt(null)} />}
    </>
  );
}